"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleModelDetails = void 0;
class VehicleModelDetails {
}
exports.VehicleModelDetails = VehicleModelDetails;
//# sourceMappingURL=VehicleModelDetails.js.map